export interface Notes {
  patientId: string;
  notes: string;
}
export const hardCodedEmptyNotes: Notes = {
  patientId: '',
  notes: '',
};

export const hardCodedNotes: Notes = {
  patientId: 'p00111',
  notes:
    'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Mauris orci ligula, vulputate in bibendum a, imperdiet non magna. Aliquam dolor ipsum, tincidunt sed mi vel, vehicula pretium tellus. Donec in sapien in lectus elementum venenatis in in odio. Integer vulputate mattis finibus. Integer sodales massa ac porta condimentum.',
};
